import axios from 'axios';
import _ from 'lodash';
import { createProspectContact } from './Coupon/CouponService';
import { PERSIST_BASKET } from '../../constants/defaults';
import bffcli from './bffcli';
const { API } = require('./../../config/' + process.env.REACT_APP_ENV);
const dotNetServer = axios.create({
  baseURL: API.SERVER,
  withCredentials: true
});

const errorHandler = err => {
  // TODO: Replace when functionality to metigate available.
  console.log(err.message);
};

const getProspectId = async () => {
  let prospectId = _.getCookie('prospect-id');
  if (!prospectId) {
    const prospectResponse = await createProspectContact();
    prospectId = prospectResponse.ProspectId;
  }
  return prospectId;
};

const getDeviceProspectId = async () => {
  let prospectId = _.getCookie('prospect-id');
  if (!prospectId) {
    const prospectResponse = await createProspectContact();
    prospectId = prospectResponse.ProspectId;
  }
  return prospectId;
};

export const getDrugBasket = async (zipCode, isFromBasket) => {
  try {
    const prospectId = await getProspectId();
    const drugBasketResponse = await bffcli.get(
      `/basket/${prospectId}?zipCode=${zipCode}&t=${new Date().getTime()}&isFromBasket=${isFromBasket}&locale=${
        window.location.href.includes('/es/') ? 'es-US' : 'en-US'
      }`,
      { withCredentials: true }
    );
    if (!_.isEmpty(drugBasketResponse.data)) {
      return drugBasketResponse.data;
    }

    return false;
  } catch (err) {
    errorHandler(err);
    return false;
  }
};

export const addDrugToBasket = async (zipCode, basketId, seoName) => {
  try {
    const prospectId = await getProspectId();
    const addBasketResponse = await bffcli.post(
      `/basket?zipCode=${zipCode}`,
      {
        prospectId,
        basketId,
        seoName,
        locale: window.location.href.includes('/es/') ? 'es-US' : 'en-US'
      },
      { withCredentials: true }
    );

    if (!_.isEmpty(addBasketResponse.data)) {
      return addBasketResponse.data;
    }

    return false;
  } catch (err) {
    errorHandler(err);
    return false;
  }
};

export const createBasketContact = async (
  pid,
  pass,
  contactTypeId,
  contactData,
  IsLoyaltyMember
) => {
  try {
    const prospectId = await getProspectId();
    let postBody = {
      PartnerId: pid,
      PartnerPass: pass,
      ContactTypeId: contactTypeId,
      UTMSource: 'direct',
      UTMMedium: 'singlecare',
      UTMCampaign: null,
      ProspectId: prospectId,
      CouponType: 1,
      CreateCard: false,
      IsLoyaltyMember,
      locale: window.location.href.includes('/es/') ? 'es-US' : 'en-US',
      domainUrl: window.location.origin
    };

    if (!_.isEmpty(contactData)) {
      postBody.Email = contactData.email || null;
      postBody.Phone = contactData.phone || 0;

      delete contactData.email;
      delete contactData.phone;
      postBody = Object.assign(postBody, contactData, {});
    }

    postBody.timezoneOffset = _.getCookie('timezone-offset');

    const createContactResponse = await dotNetServer.post(
      '/api/contact/create-drug-basket',
      postBody
    );

    if (
      !_.isEmpty(createContactResponse.data) &&
      !_.isEmpty(createContactResponse.data.Result)
    ) {
      return createContactResponse.data.Result;
    }

    return false;
  } catch (err) {
    errorHandler(err);
    return false;
  }
};

export const deleteDrugFromBasket = async (basketId, drugId, zipCode) => {
  try {
    const prospectId = await getProspectId();
    const deleteFromBasketResponse = await bffcli.delete(
      `/basket/${prospectId}/${basketId}/${drugId}?zipCode=${zipCode}&locale=${
        window.location.href.includes('/es/') ? 'es-US' : 'en-US'
      }`,
      { withCredentials: true }
    );

    if (!_.isEmpty(deleteFromBasketResponse.data)) {
      return deleteFromBasketResponse.data;
    }

    return false;
  } catch (err) {
    errorHandler(err);
    return false;
  }
};

export const clearDrugBasket = async basketId => {
  try {
    const prospectId = await getProspectId();
    const clearBasketResponse = await bffcli.delete(
      `/basket/${prospectId}/${basketId}?locale=${
        window.location.href.includes('/es/') ? 'es-US' : 'en-US'
      }`,
      { withCredentials: true }
    );
    if (!_.isEmpty(clearBasketResponse.data)) {
      return true;
    }
  } catch (err) {
    errorHandler(err);
    return false;
  }
};

export const editDrugItem = async (
  basketId,
  drugId,
  ndc,
  quantity,
  zipCode
) => {
  try {
    const prospectId = await getProspectId();
    const editBasketItem = await bffcli.put(
      `/basket/${prospectId}/${basketId}/${drugId}?zipCode=${zipCode}`,
      {
        ndc,
        quantity,
        locale: window.location.href.includes('/es/') ? 'es-US' : 'en-US'
      },
      { withCredentials: true }
    );
    if (!_.isEmpty(editBasketItem.data)) {
      return editBasketItem.data;
    }
  } catch (err) {
    errorHandler(err);
    return false;
  }
};

export const addUpdatedDrug = async (basketId, ndc, quantity, zipCode) => {
  try {
    const prospectId = await getProspectId();
    const addBasketResponse = await bffcli.post(
      `/basket/add-updated-drug?zipCode=${zipCode}`,
      {
        prospectId,
        basketId,
        ndc,
        quantity,
        locale: window.location.href.includes('/es/') ? 'es-US' : 'en-US'
      },
      { withCredentials: true }
    );

    if (!_.isEmpty(addBasketResponse.data)) {
      return addBasketResponse.data;
    }

    return false;
  } catch (err) {
    errorHandler(err);
    return false;
  }
};

export const cloneBasket = async memberProspectId => {
  try {
    const deviceProspectId = await getDeviceProspectId();
    await bffcli.post(
      `/drugbasket/v1/cloneDrugBasket`,
      {
        deviceProspectId,
        memberProspectId,
        persistExisitingBasket: PERSIST_BASKET,
        locale: window.location.href.includes('/es/') ? 'es-US' : 'en-US'
      },
      { withCredentials: true }
    );
  } catch (err) {
    errorHandler(err);
    return false;
  }
};
